import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React from 'react';
export function Table(t0) {
  const $ = _c(15);
  const {
    body,
    className,
    head,
    notes
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("mt-6lg:mt-8 relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== head) {
    t2 = <thead>{head}</thead>;
    $[2] = head;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== body) {
    t3 = <tbody>{body}</tbody>;
    $[4] = body;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="after:bg-shadow-gradient relative after:absolute after:top-0 after:right-0 after:block after:h-full after:w-3 lg:after:content-none"><div className="relative w-full overflow-x-auto"><table className="seoTable">{t2}{t3}</table></div></div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== notes) {
    t5 = notes && <div className="mt-2 flex-col gap-1">{notes.map(_temp)}</div>;
    $[9] = notes;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t1}>{t4}{t5}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(note, i) {
  return <div key={i} className="text-sm whitespace-normal text-gray-500">{note}</div>;
}